<template>
    <!-- 招生简章-->
    <div style="position: relative;top:115px;">
        <div class="fullSlide1">
            <div class="bd">
                <ul>
                    <li style="background:url(../static/img/banner2.jpg) top center no-repeat;">
                        <a>&nbsp;</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="md2018040401lty"  style="min-width: 500px;">
            <div class="container" id="containerList">
                <div class="md-com-list">
                    <div class="md-hd">
                        <ul class="md-bd clearfix md-2018040201-lty">
                            <li @click="affirm(5)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic" style="background: #006ad2;color: white;font-size: 25px;font-weight: 600;display: grid;align-items: center;text-align: center;">
                                        职业技能认定
                                </div>
                            </li>
                            <li @click="affirm(4)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><div class="hd-pic" style="background: #006ad2;color: white;font-size: 25px;font-weight: 600;display: grid;align-items: center;text-align: center;">
                                    十四个新兴产业集群培训
                            </div></div>
                            </li>
                            <li @click="affirm(3)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><div class="hd-pic" style="background: #006ad2;color: white;font-size: 25px;font-weight: 600;display: grid;align-items: center;text-align: center;">
                                    新型学徒制
                            </div></div>
                            </li>
                            <li @click="affirm(2)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><div class="hd-pic" style="background: #006ad2;color: white;font-size: 25px;font-weight: 600;display: grid;align-items: center;text-align: center;">
                                    高级研修班
                            </div></div>
                            </li>
                            <li @click="affirm(1)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><div class="hd-pic" style="background: #006ad2;color: white;font-size: 25px;font-weight: 600;display: grid;align-items: center;text-align: center;">
                                    互联网+职业技能培训
                            </div></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <el-backtop>
        </el-backtop>
    </div>
</template>

<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {
            //homePage
        },
        data() {
            return {
                loadingFlag: false,
                total: 0,   //一共多少条
                pagesize: 4,  //一页几条
                currentPage: 1,//当前页
                navId: '',
                navigationName: '',
                tableData: []
            }
        },
        created() {

        },
        methods: {
            homePage() {
                this.$router.push({ path: '/homePage' })
            },
            detail(item) {
                this.$router.push({ path: '/journalismNoticeDetail/' + item.id + "/" + item.navName })
            },
            imgerrorfun(index) {
                this.tableData[index].src = '../static/img/logo.png';
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            }
        }
    }
</script>


<style scoped>

.container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1228px;
    }

    .md-com-list .md-hd {
        padding: 15px 0 15px;
        line-height: 27px;
        overflow: hidden;
    }

    .md-2018040201-lty .pic-box {
        position: relative;
        transition: all .1s ease;
        overflow: hidden;
        width: 224px;
        margin: 0 10px;
        border-radius: 5px;
        margin-bottom: 20px;
    }

    .pull-left {
        float: left;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 160px;
        position: relative;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .md-19120602-xxw .state,
    .md-2018040201-lty .pic-box .state {
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 44px;
        z-index: 2;
        display: none;
    }

    .pageBT .en {
        width: 100%;
        color: #cacaca;
        font-size: 18px;
        font-family: "impact";
        height: 20px;
    }

    .pageBT .zh span {
        background-color: #fff;
        padding: 0px 32px;
        font-size: 30px;
        position: relative;
        top: 6px;
    }

    .pageBT .zh {
        border-bottom: 1px solid #e5e5e5;
        width: 586px;
        margin: 0px auto 22px;
        height: 28px;
    }

    .pageBT {
        color: #575757;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
        zoom: 1;
    }
    .floatDbg {
        width: 120px;
        height: 20px;
        background: url(../../static/f/img/online_botbg.jpg) no-repeat;
    }

    .floatDtt {
        width: 120px;
        height: 45px;
        line-height: 45px;
        background: #00aeef;
        color: #fff;
        font-size: 18px;
        text-indent: 22px;
        position: relative;
    }

    #rightArrow {
        right: 120px;
        background-position: 0px 0px;
        width: 50px;
        height: 145px;
        background: url(../../static/f/img/online_arrow.jpg) no-repeat;
        position: fixed;
        top: 180px;
        right: -5px;
        z-index: 9999;
        background-position: -50px 0;
    }

    #floatDivBoxs {
        right: 0px;
        width: 120px;
        background: #fff;
        position: fixed;
        top: 180px;
        right: -125px;
        z-index: 999;
    }

    .animationLeftExpose {
        animation: moveLeftExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    .animationRightExpose {
        animation: moveRightExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    @keyframes moveLeftExpose {
        from {
            right: 0px;
        }

        to {
            right: 120px;
        }
    }

    @keyframes moveRightExpose {
        from {
            right: 120px;
        }

        to {
            right: 0px;
        }
    }

    .animationLeft {
        animation: moveLeft 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    .animationRight {
        animation: moveRight 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    @keyframes moveLeft {
        from {
            right: -120px;
        }

        to {
            right: 0px;
        }
    }

    @keyframes moveRight {
        from {
            right: 0px;
        }

        to {
            right: -120px;
        }
    }

    .a {
        position: absolute;
        left: 0;
        top: 65px;
        min-width: 100%;
        line-height: 36px;
        padding: 5px 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        border: 1px solid #d2d2d2;
        background-color: #fff;
        z-index: 100;
        border-radius: 2px;
        white-space: nowrap;
    }

    .bd {
        margin: 0 auto;
        width: 100% !important;
        position: relative;
        z-index: 0;
    }

    .mian {
        min-width: 1200px;
        padding-top: 15px;
    }

    .page_box {
        width: 100%;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        clear: both;
    }

    .page_box_right {
        width: 1200px;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
    }

    #fitslist {
        padding: 0 15px;
        min-height: 400px;
    }

    #fitslist .index_6_2_1_4 {
        width: 100%;
        height: 110px;
        padding-bottom: 25px;
        border-bottom: #eeeeee solid 1px;
        margin-top: 15px;
        float: left;
    }

    #fitslist .index_6_2_1_4_1 {
        width: 200px;
        height: 110px;
        overflow: hidden;
        text-align: center;
        float: left;
    }

    #fitslist .index_6_2_1_4_2 {
        width: 900px;
        height: 110px;
        padding: 0 15px;
        float: left;
    }

    .clearfix {
        display: block;
        clear: both;
    }
</style>


// WEBPACK FOOTER //
// src/components/enrollmentGuide.vue